import { AmplitudeFlagKey, AmplitudeVariantValue } from "@simplyk/common";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { useAmplitudeFeatureFlag } from "@/common/hooks/amplitude/useAmplitudeFeatureFlag";

export const useEventFeatureBannersVariant = () => {
  const { organization } = useCurrentUserContext();

  const { loading, value } = useAmplitudeFeatureFlag({
    flagKey: AmplitudeFlagKey.EventFeatureBanners,
    organizationId: organization?.id,
    organizationProperties: { organization_zeffy_id: organization?.id || "" },
    skip: !organization?.id,
  });

  return { variant: value ?? AmplitudeVariantValue.OFF, loading };
};
